module.exports = function() {
  return new Worker(__webpack_public_path__ + "df02ad615a58d73aa56d.worker.js");
};


//////////////////
// WEBPACK FOOTER
// ./node_modules/worker-loader/dist/cjs.js?{}!./node_modules/comlink-loader/dist/comlink-worker-loader.js!./node_modules/babel-loader/lib!./node_modules/eslint-loader??ref--0!./src/workers/ecgfilter.worker.js
// module id = 5Qsx
// module chunks = 2